export const roles = {
  USER: "USER",
  SDR: "SDR",
  BDM: "BDM",
  CSM: "CSM",
  GROWTH: "GROWTH",
  DIRECTOR: "DIRECTOR",
  ADMIN: "ADMIN",
};
